export default {
  billing_page: {
    title: 'Información del Plan',
    table: {
      plan_type_row: {
        plan_type: 'Tipo de Plan',
        extend_plan_button: 'Extender Plan',
      },
      active_users_row: {
        active_user: 'Usuarios Activos',
        admin_link: 'Administrar',
      },
      item_numbers_row: {
        item_numbers: 'Número de Ítems',
        admin_link: 'Administrar',
      },
      active_orgs_row: {
        active_org: 'Organizaciones Activas',
        total_orgs: '1',
        admin_link: 'Administrar',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/account/billing.js